import * as types from "../actions/types/catalogue.types";

const initialState = {
    itemsState: "idle",
    catalogueItems: null,
    categoryState: "idle",
    categories: null,
    catalogueStatusData: null,
    getCatalogueStatusState: "idle",
    salesDeviceState: "idle",
    salesDevices: null,
    orderHistory: null,
    orderHistoryState: "idle",
};

export const catalogueReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_CATALOGUE_ITEMS_STARTED:
            return {
                ...state,
                itemsState: "loading",
            };
        case types.FETCH_CATALOGUE_ITEMS_SUCCEEDED:
            return {
                ...state,
                itemsState: "success",
                catalogueItems: action.payload,
            };
        case types.FETCH_CATALOGUE_ITEMS_FAILED:
            return {
                ...state,
                itemsState: "failed",
            };
        case types.FETCH_CATALOGUE_CATEGORY_STARTED:
            return {
                ...state,
                categoryState: "loading",
            };
        case types.FETCH_CATALOGUE_CATEGORY_SUCCEEDED:
            return {
                ...state,
                categoryState: "success",
                categories: action.payload,
            };
        case types.FETCH_CATALOGUE_CATEGORY_FAILED:
            return {
                ...state,
                categoryState: "failed",
            };
        case types.GET_CATALOGUE_STATUS_STARTED:
            return {
                ...state,
                getCatalogueStatusState: "loading",
            };
        case types.GET_CATALOGUE_STATUS_SUCCEEDED:
            return {
                ...state,
                getCatalogueStatusState: "success",
                catalogueStatusData: action.payload,
            };
        case types.GET_CATALOGUE_STATUS_FAILED:
            return {
                ...state,
                getCatalogueStatusState: "failed",
            };

        case types.FETCH_SALES_DEVICES_STARTED:
            return {
                ...state,
                salesDeviceState: "loading",
            };
        case types.FETCH_SALES_DEVICES_SUCCEEDED:
            return {
                ...state,
                salesDeviceState: "success",
                salesDevices: action.payload,
            };
        case types.FETCH_SALES_DEVICES_FAILED:
            return {
                ...state,
                salesDeviceState: "failed",
            };

        case types.FETCH_ORDER_HISTORY_STARTED:
            return {
                ...state,
                orderHistoryState: "loading",
            };
        case types.FETCH_ORDER_HISTORY_SUCCEEDED:
            return {
                ...state,
                orderHistoryState: "success",
                orderHistory: action.payload,
            };
        case types.FETCH_ORDER_HISTORY_FAILED:
            return {
                ...state,
                orderHistoryState: "failed",
            };
        default:
            return state;
    }
};
